<div class="card" style="padding:0;overflow:hidden; margin-top: 24px;">
  <div style="padding:14px 20px 1px 10px;display:flex;align-items:center;justify-content:space-between;">
    <div class="section-title">
      <!-- <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#7200c8" stroke-width="2.2">
        <polyline points="1 4 1 10 7 10" />
        <path d="M3.51 15a9 9 0 1 0 .49-3.51" />
      </svg> -->
      <mat-icon color="primary" style="font-size: 22px;">schedule</mat-icon>

      Process History
    </div>
  </div>

  <div>
    <form [formGroup]="filterForm" (ngSubmit)="applyFilter()">
      <div class="filter-row">

        <div class="col-2">
          <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
            <mat-label>From Date</mat-label>
            <input readonly matInput appInputtext [matDatepicker]="startPicker" formControlName="startDate"
              selectable="isSelectable(date,type)" id="startDate" autocomplete="off" placeholder="From Date"
              class="custom-input-border" specialIsAlphaNumeric>
            <mat-datepicker-toggle matSuffix [for]="startPicker" style="color:black;"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-2">
          <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
            <mat-label>To Date</mat-label>
            <input readonly matInput appInputtext [matDatepicker]="endPicker" formControlName="endDate"
              selectable="isSelectable(date,type)" id="endDate" autocomplete="off" placeholder="To Date"
              class="custom-input-border" specialIsAlphaNumeric>
            <mat-datepicker-toggle matSuffix [for]="endPicker" style="color:black;"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-2">
          <mat-form-field appearance="fill" hideRequiredMarker>
            <mat-label>Process Type</mat-label>

            <mat-select class="scrollbarcs" formControlName="processType">

              <mat-option [value]="3">Suspension Process</mat-option>
              <mat-option [value]="5">Pre-Notification</mat-option>

            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-2">
          <mat-form-field appearance="fill" hideRequiredMarker>
            <mat-label>Debit Order</mat-label>
            <mat-select class="scrollbarcs" formControlName="debitOrderDate" placeholder="All Debit Orders">
              <mat-option value="">All Debit Orders</mat-option>
              <mat-option *ngFor="let item of debitDates" [value]="item.key" style="overflow-y: scroll !important;">
                {{item.value}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-2">
          <mat-form-field appearance="fill" hideRequiredMarker>
            <mat-label>Status</mat-label>
            <mat-select class="scrollbarcs" formControlName="status" placeholder="All Statuses">
              <mat-option value="">All</mat-option>
              <mat-option *ngFor="let item of statusList" [value]="item.key">
                {{item.value}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </form>

    <div class="col-xl-12 mt-3 mb-4 d-flex justify-content-center">

      <button class="btn btn-secondary mr-3" (click)="applyFilter()">
        <i class="fa fa-search mr-2"></i>Search
      </button>
      <button class="btn btn-secondary  btn_danger" (click)="refresh()">
        <i class="fa fa-refresh mr-2"></i>Reset
      </button>
    </div>

  </div>
  <div style="overflow-x:auto">
    <mat-table [dataSource]="dataSource" class="upcoming-table">
      <ng-container matColumnDef="type">
        <mat-header-cell *matHeaderCellDef>Process Type</mat-header-cell>
        <mat-cell *matCellDef="let r" [ngStyle]="getTypeStyles(r.processTypeDesc)">{{r.processTypeDesc}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="debitOrderDate">
        <mat-header-cell *matHeaderCellDef>Debit Order</mat-header-cell>
        <mat-cell *matCellDef="let r"><span class="tag">{{r.debitDateTypeDesc }} - {{r.targetMonth |
            date:'MMMM'}}</span></mat-cell>
      </ng-container>

      <!-- <ng-container matColumnDef="date">
        <mat-header-cell *matHeaderCellDef>Run Date</mat-header-cell>
        <mat-cell *matCellDef="let r">
          {{ r.processType == 3 ? (r.suspensionDate | date:'dd/MM/yyyy') : (r.preNotificationDate | date:'dd/MM/yyyy')}}
        </mat-cell>
      </ng-container> -->

      <ng-container matColumnDef="processed">
        <mat-header-cell *matHeaderCellDef>Processed At</mat-header-cell>
        <mat-cell *matCellDef="let r">
          {{r.suspensionDate | date:'dd/MM/yyyy'}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="count">
        <mat-header-cell *matHeaderCellDef>Count</mat-header-cell>
        <mat-cell *matCellDef="let r"><b>{{ r.count}}</b></mat-cell>
      </ng-container>

      <ng-container matColumnDef="scheduledBy">
        <mat-header-cell *matHeaderCellDef>Scheduled By</mat-header-cell>
        <mat-cell *matCellDef="let r">{{r.creationUserId}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
        <mat-cell *matCellDef="let r">
          <span class="badge"
            [ngClass]="r.processStatusTypeDesc === 'Success' || r.status === 'Success' ? 'badge-success' : 'badge-warn'">
            <span class="dot"
              [ngClass]="r.processStatusTypeDesc === 'Success' || r.status === 'Success' ? 'dot-green' : 'dot-amber'"></span>
            {{r.processStatusTypeDesc}}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="report">
        <mat-header-cell *matHeaderCellDef>Report</mat-header-cell>
        <mat-cell *matCellDef="let r">
          <button style="background:none;border:none;cursor:pointer;color:#7200c8;font-size:18px" title="Download"
            (click)="download(r)">
            <i class="fas fa-download"></i>
          </button>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>

    <div *ngIf="dataSource.data.length === 0" class="p-4 text-center text-muted">
      No records found matching filters.
    </div>
    <div class="d-flex">
      <div class="col-6" style="padding:12px 20px;font-size:12px;color:#aaa;border-top:.5px solid #f0eaff; 
            display: flex; justify-content: space-between; align-items: center;">
        <div>
          Showing <span>{{dataSource.data.length}}</span> of <span>{{totalRecords}}</span> records
        </div>
      </div>
      <div class="col-6 table_pagenation d-flex justify-content-end">
        <mat-paginator #paginator [length]="totalRecords" [pageIndex]="pageNumber - 1" *ngIf="totalRecords>0"
          [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 20]" (page)="onPageChange($event)">
        </mat-paginator>
      </div>
    </div>
  </div>